import React from 'react';

const IconLargeOrderWarning = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M7 1.75L12.5 11.25H1.5L7 1.75Z'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinejoin='round'
    />
    <path
      d='M7 5.25V8'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
    <circle cx='7' cy='9.75' r='0.75' fill='currentColor' />
  </svg>
);

export default IconLargeOrderWarning;
